import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.pagenation');
import { OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-pagenation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.pagenation/view.scss */
.pagenation {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn {
  border-radius: 32px;
  width: 30px;
  height: 30px;
  margin: 0 3px;
}
.btn.disabled {
  opacity: 0.2;
}
.btn:hover {
  background-color: #5667E4;
  color: white;
  border: 2px solid #5667E4;
}`],
})
export class PortalSeasonPagenationComponent implements OnInit, OnChanges {
    @Input() current: any = 1;
    @Input() start: any = 1;
    @Input() end: any = 1;
    @Input() maxlength: any = 10;
    @Output() pageMove = new EventEmitter<number>();

    public list: Array<number> = [];

    constructor(@Inject( Service)         public service: Service,    ) { }

    public async ngOnInit() {
        this.Math = Math;
    }

    public async ngOnChanges() {
        this.list = [];
        for (let i = 0; i < this.maxlength; i++) {
            if (this.start + i > this.end) break;
            this.list.push(this.start + i);
        }
        await this.service.render()
    }

    public move(page: number) {
        this.pageMove.emit(page);
    }
}

export default PortalSeasonPagenationComponent;